import React from 'react';
import moment from 'moment';

import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import EventIcon from '@mui/icons-material/Event';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useTheme } from '@mui/material/styles';

import Modal from '../../modals/Modal';
import Button from '../../shared/Button';

import './case-approve-date-modal.scss';

const CaseApproveConsultationDateModal = (props) => {
  const { open, onClose, selectedCase, onApprove, onReject, loading } = props;
  const theme = useTheme();

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Approve New Consultation Date"
      subtitle={selectedCase?.formattedId || selectedCase?.id}
      size="md"
      autoSize
    >
      <div className="approve_surgery_date_modal">
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <div className="p-lg width-100">
            <div className="secondary">Current Consultation Date</div>

            {selectedCase?.consultationDate ? (
              <DatePicker
                desktopModeMediaQuery="(min-width: 0px)"
                format="DD/MM/YYYY"
                value={moment(selectedCase.consultationDate)}
                disabled
                slotProps={{
                  textField: {
                    fullWidth: true,
                    variant: 'standard',
                  },
                }}
              />
            ) : (
              <TextField
                fullWidth
                disabled
                value="TBC"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <EventIcon style={{ fill: theme.palette.text.secondary, marginRight: '4px' }} />
                    </InputAdornment>
                  ),
                }}
              />
            )}
          </div>

          <div className="p-lg width-100">
            <div className="secondary">Requested New Consultation Date</div>
            <DatePicker
              desktopModeMediaQuery="(min-width: 0px)"
              format="DD/MM/YYYY"
              value={moment(
                selectedCase?.requestedConsultationDate?.newDate ||
                selectedCase?.requestedConsultationDateNew
              )}
              disabled
              slotProps={{
                textField: {
                  fullWidth: true,
                  variant: 'standard',
                },
              }}
            />
          </div>
        </LocalizationProvider>

        {/* Desktop buttons */}
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <div className="p-lg width-100 d-flex space-between">
            <div className="m-r-md">
              <Button
                text="Reject"
                type="secondary"
                onClick={onReject}
                disabled={loading}
                loading={loading}
              />
            </div>
            <div className="m-l-md">
              <Button
                text="Approve"
                color="primary"
                onClick={onApprove}
                disabled={loading}
                loading={loading}
              />
            </div>
          </div>
        </Box>

        {/* Mobile buttons */}
        <Box sx={{ display: { md: 'none' } }}>
          <div className="p-md width-100 d-flex direction-column align-center">
            <div className="m-b-lg">
              <Button
                text="Approve"
                color="primary"
                onClick={onApprove}
                disabled={loading}
                loading={loading}
              />
            </div>
            <div>
              <Button
                text="Reject"
                type="secondary"
                onClick={onReject}
                disabled={loading}
                loading={loading}
              />
            </div>
          </div>
        </Box>
      </div>
    </Modal>
  );
};

export default CaseApproveConsultationDateModal;
